import { render, staticRenderFns } from "./AnalyticsSupport.vue?vue&type=template&id=52ac99f9&"
import script from "./AnalyticsSupport.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsSupport.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports